// extracted by mini-css-extract-plugin
export default {"title":"how-to-use-tabs_title__Pdiiq","content":"how-to-use-tabs_content__e9KDR","contentWrap":"how-to-use-tabs_contentWrap__kNkyU","text":"how-to-use-tabs_text__W2guk"};